import { Metadata } from '../../../../../utils/spds/metadata';
import Super from '../base.gjs';
import styles from './info.module.scss';

const METADATA = Metadata.define({
  description: 'Primary info badge indicator.',
  name: 'Info Primary Badge',
});

export default class SpdsIndicatorBadgeInfoPrimary extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  variantClass = 'spds-indicator-badge-info';
  variantStyles = styles;
}

export const BADGE_INFO_PRIMARY_METADATA = SpdsIndicatorBadgeInfoPrimary.metadata;
